<template><TableWlVisits /></template>
<script>
import TableWlVisits from '../visits/TableWlVisits.vue'
export default { name: 'ReportVisits', components: { TableWlVisits } }
</script>
